import {Link} from '@nlabs/gothamjs/router';

import type {ReactElement} from 'react';

interface LegalPageProps {
  readonly kind: 'privacy' | 'terms';
}

const notices = {
  privacy: [
    {body: 'The local preview stores account details, password hashes, session records, project content, and mailing-list preferences on the development server. Passwords are stored as hashes, not readable passwords. New signups join the mailing list for product updates unless they check the opt-out box.', title: 'Data in the preview'},
    {body: 'Signing in uses an HttpOnly session cookie. Password recovery and verification currently use demo links shown in the app; no verification or recovery email is sent in this mode.', title: 'Sessions and email'},
    {body: 'The production privacy policy, including retention, service providers and privacy request contact details, will be published before public launch. This preview notice is not the final privacy policy.', title: 'Before launch'}
  ],
  terms: [
    {body: 'ReactorBox is currently a development preview. Free accounts support story planning, projects, and characters. Generation and video storage require a paid plan, and the app does not currently offer paid subscriptions or checkout.', title: 'Preview service'},
    {body: 'Plan names, prices, generation allowances and availability are being finalized. The pricing page describes the proposed offering, not an active paid subscription.', title: 'Plans and availability'},
    {body: 'The full terms of service, including content rights, acceptable use, billing and cancellation terms, will be published before public launch. This preview notice is not the final terms of service.', title: 'Before launch'}
  ]
};

export const LegalPage = ({kind}: LegalPageProps): ReactElement => (
  <article className="mx-auto max-w-3xl px-5 py-16 sm:px-8 sm:py-24">
    <p className="text-sm font-medium text-sky-200">ReactorBox · Preview notice</p>
    <h1 className="mt-4 text-4xl tracking-tight text-violet-200 sm:text-5xl">{kind === 'privacy' ? 'Privacy' : 'Terms of service'}</h1>
    <p className="mt-6 text-lg leading-8 text-white/65">ReactorBox is operated by Nitrogen Labs, Inc. These notes describe the current preview while our launch policies are being prepared.</p>
    <div className="mt-12 space-y-10">
      {notices[kind].map(({body, title}) => (
        <section key={title}>
          <h2 className="text-xl font-medium text-violet-200">{title}</h2>
          <p className="mt-3 leading-7 text-white/65">{body}</p>
        </section>
      ))}
    </div>
    <Link className="mt-12 inline-flex rounded-full border border-sky-300/30 px-5 py-3 text-sm text-sky-200 transition hover:bg-sky-300/10" to="/">Back to ReactorBox</Link>
  </article>
);
